/*LIBRARY*/
import { useEffect, useState, useCallback, useRef } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import CustomToolbarContainerNested from "./CustomToolbarContainerNested";
import NumberAndActionNested from "../custom_cell/NumberAndActionNested";
import Modal from "../common_modal/Modal";
import GENERATE_ROW_BULK from "./GENERATE_ROW_BULK";

/*REDUX*/
import { edit_child_cell } from "../../App/actions/crudNestedTable";
import { deleteField } from "../../App/actions/layerActions";

/*PICTURE*/
import ICON_PLUS from "../../Assets/jsx/ICON_PLUS";

/*FUNCTION*/
import is_empty from "../../App/validation/is-empty";
import {
  convertFieldsToHeadersForSecondGenOrMore,
  convertPropertiesToDataList,
  packThePropertiesDataToUseApiEditNested,
} from "../../App/validation/convert_data";
import {
  getChildrenFeaturesByColumnParentUuidAndRowParentUuid,
  getFeatureByKey,
  getGeoLayerById,
} from "../../App/reduxHelper/layer";

/*DATA*/
import dict from "../../Data/dict.json";
import { StyledDataGrid } from "../../Style/trivial/StyledDataGrid";
import EDIT_FIELD from "./EDIT_FIELD";

/*CONST*/

const PARENT_TABLE_NESTED_EDIT = ({
  row,
  column,
  layer,
  map,
  // geo_layer,
  selected_parent_table_row_key,
  auth,
  is_from_first_gen_table,
  edit_child_cell,
  deleteField,
}) => {
  const { layer_id, geo_layer_list } = layer;
  const geo_layer = geo_layer_list?.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;

  const component_id = row?.key;
  const field_parent = column?.uuid;

  const [state, setState] = useState({
    layer_id: "",
    headers: [],
    data_list: [],
    fields: [],
    field: {},
    old_cell: {},
    child_fields_shown: [],
    modal_delete_field: false,
    modal_edit_field: false,
    modal_push_field: false,
    modal_menu: false,
    modal_generate_row_bulk: false,
  });

  const prevPropsRef = useRef();

  const get_children_features = useCallback(
    (rowParam, columnParam) => {
      const feature = getFeatureByKey({
        geo_layer,
        feature_key: selected_parent_table_row_key || rowParam?.key,
      });
      let row_parent_uuid = null;
      if (!is_from_first_gen_table) {
        if (rowParam?.child_uuid) {
          row_parent_uuid = rowParam?.child_uuid;
        } else if (rowParam?.key) {
          row_parent_uuid = rowParam?.key;
        }
      }
      let child_features =
        getChildrenFeaturesByColumnParentUuidAndRowParentUuid({
          feature,
          column_parent_uuid: columnParam?.uuid,
          row_parent_uuid,
        });
      return child_features;
    },
    [geo_layer, selected_parent_table_row_key, is_from_first_gen_table]
  );

  const handleEditCellChange = useCallback(
    (edit_properties_callback, layer_id_param, params) => {
      const body = packThePropertiesDataToUseApiEditNested(
        layer_id_param,
        params
      );
      edit_properties_callback(body);
    },
    []
  );

  const toggle_edit_field = useCallback((params) => {
    setState((prevState) => {
      const field = prevState.fields.find((f) => f?.key === params?.field);
      return {
        ...prevState,
        modal_edit_field: !prevState.modal_edit_field,
        field: field || {},
      };
    });
  }, []);

  const toggle_delete_field = useCallback((params) => {
    setState((prevState) => {
      const field = prevState.fields.find((f) => f?.key === params?.field);
      return {
        ...prevState,
        modal_delete_field: !prevState.modal_delete_field,
        field: field || {},
      };
    });
  }, []);

  const on_render = useCallback(
    (child_fields_shown) => {
      const language = localStorage?.language || "ina";
      const { geo_layer_list = [] } = layer;
      const feature_parent = getFeatureByKey({
        geo_layer,
        feature_key: selected_parent_table_row_key,
      });
      const fields = geo_layer?.fields || [];
      const fields_child = fields.filter(
        (f) => f?.parent_uuid === field_parent
      );
      let child_array = child_fields_shown || [];
      const headers = convertFieldsToHeadersForSecondGenOrMore(
        {
          fields: fields_child,
          layer_id,
          sortedFeatures: child_array,
        },
        {
          handleEditCellChange: handleEditCellChange,
          toggleEditField: toggle_edit_field,
          toggleDeleteField: toggle_delete_field,
          editProperties: edit_child_cell,
        }
      );
      const id_pembanding = geo_layer?.layer_data_list?.[0]?._id;
      const layer_pembanding = geo_layer_list.find(
        (item) => item?.geo_layer?._id === id_pembanding
      )?.geo_layer;

      const deleteColumn = {
        field: "no",
        headerName: "No.",
        width: 80,
        sortable: false,
        renderHeader: () => {
          return <>No.</>;
        },
        renderCell: (params) => {
          return (
            <NumberAndActionNested
              geo_layer_id={layer_id}
              feature_key={selected_parent_table_row_key || row?.key}
              child_uuid={params?.row?.key}
              params={params}
              component_id={component_id}
            />
          );
        },
      };
      headers.unshift(deleteColumn);

      const newColumn = {
        field: "add_column",
        headerName: "Add Column",
        width: 150,
        sortable: false,
        editable: false,
        renderHeader: () => {
          const username = auth.user?.name?.trim() || ""
          const domain = window.location.host;
          const restrictedDsdaAccess = [
            "localhost:3003",
            "dsdajakarta.mapid.io",
            "dsdajakarta-alpha.mapid.io",
            "dsdajakarta-beta.mapid.io",
          ].includes(domain) && 
          !["dsdajakarta","pusdatin_SDA"].includes(username)

          return (
            <>
              {restrictedDsdaAccess ? 
                (<></>) :
                (<button
                  onClick={toggle_menu}
                  className="button_pill background_white margin_bottom margin_right"
                  id="new_column"
                >
                  <span className="badge_circle background_black margin_right">
                    <ICON_PLUS />
                  </span>
                  {dict?.["Add"]?.[language]}
                </button>)
              }
            </>
          );
        },
      };
      headers.push(newColumn);

      const data_list = convertPropertiesToDataList({
        features: child_array,
        fields: fields_child,
        layer_pembanding,
        feature_parent,
        source: "Parent table nested editor",
        nested_attributes: {
          feature_key: selected_parent_table_row_key || row?.key,
        },
      });

      setState((prevState) => ({
        ...prevState,
        layer_id: layer.layer_id,
        headers: headers,
        data_list: data_list,
        fields: fields,
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      layer,
      geo_layer,
      selected_parent_table_row_key,
      field_parent,
      layer_id,
      row,
      component_id,
      handleEditCellChange,
      toggle_edit_field,
      toggle_delete_field,
      edit_child_cell,
    ]
  );

  const toggle_menu = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      modal_menu: !prevState.modal_menu,
    }));
  }, []);

  useEffect(() => {
    const { child_fields_shown } = layer;
    setState((prevState) => ({
      ...prevState,
      child_fields_shown,
    }));
    on_render(child_fields_shown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const prevProps = prevPropsRef.current;

    if (prevProps) {
      const prevLayer = prevProps?.layer;
      const prevMap = prevProps?.map;
      const prev_geo_layer = prevProps?.geo_layer;

      const isHeaderAnyChange =
        prev_geo_layer?.fields?.length !== geo_layer?.fields?.length;

      const shouldUpdate =
        map.status_action !== prevMap.status_action ||
        JSON.stringify(prevLayer?.child_fields_shown) !==
          JSON.stringify(layer?.child_fields_shown) ||
        layer.selected_parent_table_row_key !==
          prevLayer.selected_parent_table_row_key ||
        layer.is_nested_table_filtered !== prevLayer.is_nested_table_filtered ||
        (layer.is_nested_table_filtered &&
          JSON.stringify(prevLayer?.filtered_childs_shown) !==
            JSON.stringify(layer.filtered_childs_shown)) ||
        isHeaderAnyChange;

      if (shouldUpdate) {
        let child_features;

        if (layer.is_nested_table_filtered) {
          child_features = layer.filtered_childs_shown;
        } else {
          child_features = get_children_features(row, column);
        }

        if (
          JSON.stringify(state.child_fields_shown) !==
            JSON.stringify(child_features) ||
          isHeaderAnyChange
        ) {
          setState((prevState) => ({
            ...prevState,
            child_fields_shown: child_features,
          }));
          on_render(child_features);
        }
      }
    }

    prevPropsRef.current = { layer, map, geo_layer };
  }, [
    layer,
    map,
    geo_layer,
    row,
    column,
    get_children_features,
    on_render,
    state.child_fields_shown,
  ]);

  const handleDeleteField = useCallback(() => {
    const body = {
      geo_layer_id: state.layer_id,
      field_key: state.field?.key,
    };
    deleteField(body);
    setState((prevState) => ({
      ...prevState,
      modal_delete_field: false,
    }));
  }, [state.layer_id, state.field, deleteField]);

  const toggle_generate_row_bulk = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      modal_generate_row_bulk: !prevState.modal_generate_row_bulk,
      modal_menu: false,
    }));
  }, []);

  const toggle_push_field = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      modal_push_field: !prevState.modal_push_field,
      modal_menu: false,
    }));
  }, []);

  // const handlePreviewText = useCallback((value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     text: value,
  //   }));
  // }, []);

  /**
   * Keterangan:
   *
   * Ketika cell diklik 2x maka akan menyimpan data sebelum ada perubahan data pada cell. Ini dilakukan dengan tujuan supaya ketika ada perubahan pada cell, aksi tersebut dapat diketahui dan akan langsung merequest API
   */
  const onCellEditStart = useCallback((params) => {
    setState((prevState) => ({ ...prevState, old_cell: params }));
  }, []);

  /**
   * Keterangan:
   *
   * Dijalankan ketika onChange dengan fitur bawaan package/library MUI Datagrid
   */
  const onCellEditCommit = useCallback(
    (event, parent_id) => {
      if (event?.target?._wrapperState) {
        const cellElement = event.currentTarget;
        const properties_key = cellElement.getAttribute("data-field");
        const child_uuid =
          state.data_list?.[+cellElement.parentElement.getAttribute("data-id")]
            ?.key;
        const value = !isNaN(event.target?.value)
          ? +event.target?.value
          : event.target?.value;
        const old_value = !isNaN(state.old_cell.value)
          ? +state.old_cell.value
          : state.old_cell.value;
        if (!is_empty(state.old_cell) && old_value !== value) {
          let newParams = state.old_cell;
          newParams.value = value;
          newParams.row.value = value;

          const { name } = auth.user;
          const newDate = new Date();
          const column_key = column?.key;
          const selected_geo_layer_list = geo_layer;
          const selected_geo_layer_fields =
            selected_geo_layer_list?.geo_layer?.fields || [];
          const updated_at_properties_key = selected_geo_layer_fields?.find(
            (item) =>
              item?.parent_uuid === column_key && item?.type === "last_edited"
          )?.key;
          const updated_by_properties_key = selected_geo_layer_fields?.find(
            (item) =>
              item?.parent_uuid === column_key && item?.type === "edited_by"
          )?.key;

          const body = {
            geo_layer_id: layer_id,
            feature_key: selected_parent_table_row_key || row?.key,
            parent_id: parent_id,
            child_uuid,
            properties_key,
            properties_value: value,
          };

          if (updated_at_properties_key) {
            body.updated_at_properties_key = updated_at_properties_key;
            body.updated_at_properties_value = newDate;
          }
          if (updated_by_properties_key) {
            body.updated_by_properties_key = updated_by_properties_key;
            body.updated_by_properties_value = name;
          }
          edit_child_cell(body);
          setState((prevState) => ({ ...prevState, old_cell: {} }));
        }
      }
    },
    [
      state.data_list,
      state.old_cell,
      auth.user,
      column,
      geo_layer,
      layer_id,
      selected_parent_table_row_key,
      row,
      edit_child_cell,
    ]
  );

  const onCellKeyDown = useCallback(
    (params, event) => {
      if (event?.key === "Enter" && params?.colDef.isImage) {
        document.getElementById(`${params?.row?.key}-${params?.field}`).click();
      } else if (event?.key === " " && params?.colDef?.isImage === false) {
        event.stopPropagation();
      } else if (event?.key === "Enter" && params?.colDef?.isDoc) {
        document.getElementById(`${params?.row?.key}-${params?.field}`).click();
      } else if (event?.key === "Enter") {
        onCellEditCommit(event, params?.colDef?._id);
      }
    },
    [onCellEditCommit]
  );

  const language = localStorage?.language || auth.language;

  const {
    data_list = [],
    headers = [],
    modal_menu,
    modal_generate_row_bulk,
    child_fields_shown,
  } = state;

  const uuid = column.uuid;
  const modal_edit_field = state.modal_edit_field && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={state.modal_edit_field}
      onClose={toggle_edit_field}
    >
      <div className="box-body" id="box-body">
        <EDIT_FIELD
          headers={headers}
          field={state.field}
          togglePushField={toggle_push_field}
          toggleEditField={toggle_edit_field}
          parent_uuid={uuid}
          from="nested_table"
        />
        {/* <EditField from="nested_table" headers={headers} field={state.field} /> */}
      </div>
    </Modal>
  );

  const modal_delete_field = state.modal_delete_field && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={state.modal_delete_field}
      onClose={(params) => toggle_delete_field(params)}
    >
      <main style={{ textAlign: "center", padding: 20 }}>
        <section className="text_medium">
          {dict["Are you sure to delete?"][language]}
        </section>
        <button
          className="button background_black"
          id="deleteBright"
          style={{ marginTop: "1rem" }}
          onClick={handleDeleteField}
        >
          {dict["Delete"][language]}
        </button>
      </main>
    </Modal>
  );

  const modal_push_field = state.modal_push_field && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={state.modal_push_field}
      onClose={toggle_push_field}
    >
      <div
        style={{
          height: "calc( 100vh - 80px )",
        }}
      >
        <EDIT_FIELD
          headers={headers}
          field={state.field}
          togglePushField={toggle_push_field}
          toggleEditField={toggle_edit_field}
          parent_uuid={uuid}
          from="nested_table"
        />
        {/* <PushField
          headers={headers}
          from="nested_table"
          layer_id={state.layer_id}
          parent_uuid={uuid}
        /> */}
      </div>
    </Modal>
  );

  const modal_menu_content = modal_menu && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={state.modal_menu}
      onClose={toggle_menu}
    >
      <div className="box-body">
        <button
          className="button_big margin_bottom background_black"
          onClick={toggle_push_field}
        >
          {dict["Add Column"][language]}
        </button>
        <br />
        <button
          className="button_big background_black"
          onClick={toggle_generate_row_bulk}
        >
          {dict["Generate arithmetic rows"][language]}
        </button>
      </div>
    </Modal>
  );

  const modal_generate_row_bulk_content = modal_generate_row_bulk && (
    <Modal
      modalSize="large"
      id="modal"
      isOpen={modal_generate_row_bulk}
      onClose={toggle_generate_row_bulk}
    >
      <div className="box-body">
        <main className="max_height">
          <GENERATE_ROW_BULK
            feature_key={selected_parent_table_row_key}
            layer_id={layer_id}
            parent_uuid={uuid}
            parent_uuid_temp={row?.properties ? "" : row?.key}
            toggle_generate_row_bulk={toggle_generate_row_bulk}
            child_fields_shown={child_fields_shown}
          />
        </main>
      </div>
    </Modal>
  );

  return (
    <main
      style={{
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 5,
        paddingRight: 5,
        width: "100%",
        height: "500px",
      }}
      className="max_height"
      onClick={(event) => event.stopPropagation()}
    >
      {modal_edit_field}
      {modal_delete_field}
      {modal_push_field}
      {modal_menu_content}
      {modal_generate_row_bulk_content}
      <StyledDataGrid
        rows={data_list}
        columns={headers}
        onCellEditStart={(params) => onCellEditStart(params)}
        slotProps={{
          cell: {
            onBlur: (event) => {
              onCellEditCommit(event);
            },
          },
          footer: {
            geo_layer_id: layer_id,
            feature_key: selected_parent_table_row_key || row?.key,
            parent_uuid: column?.uuid,
            parent_uuid_temp: row?.properties ? "" : row?.key,
            component_id: component_id,
          },
        }}
        onCellKeyDown={(params, event) => onCellKeyDown(params, event)}
        getRowHeight={() => 45}
        slots={{
          footer: CustomToolbarContainerNested,
        }}
        rowsPerPageOptions={[
          25, 50, 100, 500, 1000, 5000, 10000, 50000, 100000,
        ]}
        disableColumnMenu
      />
    </main>
  );
};

const mapStateToProps = (state, props) => ({
  auth: state.auth,
  layer: state.layer,
  map: state.map,
  geo_layer: getGeoLayerById({ layer: state.layer, layer_id: props.layer_id }),
});

export default connect(mapStateToProps, {
  edit_child_cell,
  deleteField,
})(PARENT_TABLE_NESTED_EDIT);
